__turbopack_context__.v({
  "group": "ProductList-module-scss-module__JhqHwa__group",
  "list": "ProductList-module-scss-module__JhqHwa__list",
  "root": "ProductList-module-scss-module__JhqHwa__root",
});
